/* eslint-disable */
import request from '@/utils/serviceXAuthTokenFormUrlenc'
import requestRaw from '@/utils/requestRaw'
import requestMultipart from '@/utils/requestMultipart'

import { APICore, APICoreV2 } from '@/utils/servicesApi'

export function resendMessagePrepare(data) {
  return requestRaw({
    url: APICoreV2() + '/omni/whatsapp/resend_message_prepare',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function deleteMessagePrepare(data) {
  return requestRaw({
    url: APICoreV2() + '/omni/whatsapp/delete_message_prepare',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function deleteMessage(data) {
  return requestRaw({
    url: APICoreV2() + '/omni/whatsapp/delete_message',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function resendMessage(data) {
  return requestRaw({
    url: APICoreV2() + '/omni/whatsapp/resend_message',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function sendQuickReply(data) {
  return requestRaw({
    url: APICoreV2() + '/omni/room/send-quick-reply',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function detailBroadcastSpeedInfo(data) {
  return requestRaw({
    url: APICoreV2() + '/omni/broadcast/output_info_speed',
    method: 'GET', 
  })
}
export function detailButtonsBroadcast(data) {
  return requestRaw({
    url: APICoreV2() + '/omni/broadcast/detail_buttons',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function detailBroadcast(data) {
  return requestRaw({
    url: APICoreV2() + '/omni/broadcast/detail',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function checkAnomaliBroadcast(data) {
  return requestRaw({
    url: APICoreV2() + '/omni/broadcast/check_anomali_broadcast',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function resendAnomaliBroadcast(data) {
  return requestRaw({
    url: APICoreV2() + '/omni/broadcast/resend_anomali_broadcast',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function deleteBroadcast(data) {
  return requestRaw({
    url: APICoreV2() + '/omni/broadcast/delete',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function sendBroadcastTest(data) {
  return requestRaw({
    url: APICoreV2() + '/omni/broadcast/stored_test',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function sendBroadcastImport(data) {
  return requestRaw({
    url: APICoreV2() + '/omni/broadcast/stored_import',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function sendBroadcast(data) {
  return requestRaw({
    url: APICoreV2() + '/omni/broadcast/stored',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function login(id) {
  return request({
    url: APICoreV2() + '/omni/whatsapp/login?id=' + id,
    method: 'GET',
  })
}
// export function isOnline(phone) {
//   return request({
//     url: APICore() + '/omni/whatsapp/isonline?phone=' + phone,
//     method: 'GET',
//   })
// }
export function isOnline(phone) {
  return request({
    url: APICoreV2() + '/omni/whatsapp/isonline?phone=' + phone,
    method: 'GET',
  })
}
// Pemeriksaan status koneksi tanpa alert global. Dipakai alur Lihat Chat
// agar kegagalan verifikasi ditampilkan oleh halaman Sesi AI Chat.
export function isOnlineSilent(phone) {
  return requestRaw({
    url: APICoreV2() + '/omni/whatsapp/isonline?phone=' + encodeURIComponent(phone),
    method: 'GET',
    silent: true
  })
}
// export function logout(phone) {
//   return request({
//     url: APICore() + '/omni/whatsapp/logout?phone=' + phone,
//     method: 'GET',
//   })
// }
export function logout(phone) {
  return request({
    url: APICoreV2() + '/omni/whatsapp/logout?phone=' + phone,
    method: 'GET',
  })
}

// export function sendText(data) {
//   return requestRaw({
//     url: APICore() + '/omni/room/send-text',
//     method: 'POST',
//     data: data // untuk array data post
//   })
// }

export function sendText(data) {
  return requestRaw({
    url: APICoreV2() + '/omni/room/send-text',
    method: 'POST',
    data: data // untuk array data post
  })
}

// export function sendTextMQ(data) {
//   return requestRaw({
//     url: APICore() + '/omni/room/send-textmq',
//     method: 'POST',
//     data: data // untuk array data post
//   })
// }

export function sendTextMQ(data) {
  return requestRaw({
    url: APICoreV2() + '/omni/room/send-text',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function onlyUploadFile(data) {
  return requestMultipart({
    url: APICore() + '/omni/room/only-upload-file',
    method: 'POST',
    data: data // untuk array data post
  })
}


export function sendFileMQ(data) {
  return requestMultipart({
    // url: APICore() + '/omni/room/send-filemq',
    url: APICoreV2() + '/omni/room/send-file',
    method: 'POST',
    data: data // untuk array data post
  })
}

// export function sendFile(data) {
//   return requestMultipart({
//     url: APICore() + '/omni/room/send-file',
//     method: 'POST',
//     data: data // untuk array data post
//   })
// }
export function sendFile(data) {
  return requestMultipart({
    url: APICoreV2() + '/omni/room/send-file',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function sendFilepath(data) {
  return requestRaw({
    url: APICore() + '/omni/room/send-filepath',
    method: 'POST',
    data: data // untuk array data post
  })
}



// WEBPACK FOOTER //
// ./src/api/omniwa.js